<div class="content-front">
      <div class="wrapper">
            <div class="header-title-wrapper">
                  <div *ngIf="category?.name">
                        <p> {{resultSpan}} <span i18n="@@Of">od </span>{{category?.page?.totalElements}} <span
                                    i18n="@@UKategoriji">u kategoriji: </span> <span
                                    id="category-name">{{category?.name}} </span></p>
                  </div>
                  <div>
                        <p *ngIf="!category?.name">
                              {{resultSpan}} <span i18n="@@Of">od </span> {{category?.page?.totalElements}} <span
                                    i18n="@@RezultataPretrage">rezultata pretrage: </span><span
                                    id="search-param">"{{category?.searchParam}}"</span></p>
                  </div>
            </div>
            <div class="product-header-sort-by" [formGroup]="sortForm">
                  <div class="form-control form-control-options form-control--center">
                        <mat-select formControlName="selectValue" name="sortValue">
                              <mat-option *ngFor="let sort of options" [value]="sort.key">
                                    {{sort.value}}
                              </mat-option>
                        </mat-select>
                  </div>
            </div>
            <div *ngIf="category?.page?.totalPages>1" class="paggination-wrapper">
                  <ul>
                        <li class="page-item">
                              <a class="page-link" *ngIf="!category?.page?.first"
                                    (click)='changePage(category?.pageRequest,category?.searchParam,category?.page?.number-1, "page")'>
                                    <!-- Prethodna -->
                                    <img class="icon-pagination"
                                          src="assets/icons/dark-green/arrow-ionicons-left.svg">
                              </a>
                        </li>
                        <ng-template ngFor let-page [ngForOf]="createRange(category?.page?.totalPages)"
                              let-i="index+1">
                              <li class="page-item" [ngClass]="{active:page-1 === category?.page?.number}">
                                    <a class="page-link"
                                          *ngIf="category?.page?.number <= page+1 && category?.page?.number >= page-3"
                                          (click)='changePage(category?.pageRequest,category?.searchParam,page-1, "page")'>
                                          {{page}}
                                    </a>
                              </li>
                        </ng-template>
                        <li class="page-item">
                              <a class="page-link" *ngIf="!category?.page?.last"
                                    (click)='changePage(category?.pageRequest,category?.searchParam,category?.page?.number+1, "page")'>
                                    <!-- Sledeća -->
                                    <img class="icon-pagination"
                                          src="assets/icons/dark-green/arrow-ionicons-right.svg">
                              </a>
                        </li>
                  </ul>
            </div>
      </div>
</div>